import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslate } from 'react-polyglot'
import useAxios from 'axios-hooks'
import axios from 'axios'

import EE from 'emitter.js'
import { Modal, Button, ButtonGroup, Text, Icon, Tooltip } from 'components'

import MemberList from './MemberList'
import MemberSearch from './MemberSearch'

import './responsibleMembersModal.scss'

export default ({ userId }) => {
	const [isOpen, setIsOpen] = useState(false)
	const [data, setData] = useState({
		articleId: null,
		articleCreator: null,
		responsibleMembers: [],
	})

	const [memberSearchOpen, setMemberSearchOpen] = useState(false)
	const dispatch = useDispatch()
	const t = useTranslate()

	const [{}, updateResponsibleMembers] = useAxios(
		{
			url: `articles/${data.articleId}/responsible-members`,
			method: 'PUT',
		},
		{
			manual: true,
		}
	)

	const [{ data: members }] = useAxios('teams/members')

	useEffect(() => {
		EE.on('showResponsiblePersonsModal', async props => {
			let d = props

			if (!props.articleCreator) {
				const { data } = await axios.get(`articles/${props.articleId}`)

				d = {
					...d,
					responsibleMembers: data.responsibleMembers,
					articleCreator: data.createdBy.id,
				}
			}

			setData({
				...data,
				...d,
			})

			setIsOpen(true)
		})

		return () => {
			EE.off('showResponsiblePersonsModal')
		}
	}, [])

	return (
		<Modal
			visible={isOpen}
			onClose={() => {
				setMemberSearchOpen(false)
				setIsOpen(false)
			}}
			title={t('responsible_persons')}
		>
			<Text>{t('responsible_persons_text')}</Text>

			<MemberList
				responsibleMembers={data.responsibleMembers}
				articleCreator={data.articleCreator}
				onDelete={async id => {
					const { data: rM } = await updateResponsibleMembers({
						data: {
							members: data.responsibleMembers
								.filter(rm => rm.id !== id)
								.map(rm => rm.id),
						},
					})

					dispatch({
						type: 'UPDATE_ARTICLE_META',
						id: data.articleId,
						meta: {
							responsibleMembers: rM,
						},
					})

					setData({ ...data, responsibleMembers: rM })
				}}
			/>

			{members && data.responsibleMembers && (
				<div className="c-member-modal__actions">
					<ButtonGroup orientation="horizontal">
						{members.length !== data.responsibleMembers.length ? (
							<Button
								icon={<Icon name="invite-member" />}
								onClick={() => setMemberSearchOpen(true)}
								text={t('add_member')}
							/>
						) : (
							<Tooltip
								description={t('all_members_selected')}
								trigger="click"
								noDelay
							>
								<Button
									icon={<Icon name="invite-member" />}
									onClick={() => setMemberSearchOpen(true)}
									text={t('add_member')}
									disabled
								/>
							</Tooltip>
						)}

						{data.responsibleMembers &&
							!data.responsibleMembers
								.map(m => m.id)
								.includes(userId) && (
								<Button
									icon={<Icon name="invite-member" />}
									onClick={async () => {
										const {
											data: rM,
										} = await updateResponsibleMembers({
											data: {
												members: [
													...data.responsibleMembers.map(
														m => m.id
													),
													userId,
												],
											},
										})

										dispatch({
											type: 'UPDATE_ARTICLE_META',
											id: data.articleId,
											meta: { responsibleMembers: rM },
										})

										setData({
											...data,
											responsibleMembers: rM,
										})
									}}
									text={t('add_me')}
								/>
							)}
					</ButtonGroup>
				</div>
			)}

			{memberSearchOpen && (
				<MemberSearch
					members={members.filter(
						m =>
							!data.responsibleMembers
								.map(me => me.id)
								.includes(m.id)
					)}
					onAdd={async (selected, cb) => {
						const { data: rM } = await updateResponsibleMembers({
							data: {
								members: [
									...data.responsibleMembers.map(mm => mm.id),
									...selected,
								],
							},
						})

						dispatch({
							type: 'UPDATE_ARTICLE_META',
							id: data.articleId,
							meta: { responsibleMembers: rM },
						})

						setData({ ...data, responsibleMembers: rM })

						cb()
					}}
					onClose={() => setMemberSearchOpen(false)}
				/>
			)}
		</Modal>
	)
}
